module.exports = __webpack_public_path__ + "media/images/vouchers/absolution_liftant-3a3ca2898d2be138065f51f1c5f67e4d.png";